<script>
	import Article from "../components/ui/Article.svelte";
	import SocialLinks from "../components/ui/SocialLinks.svelte";
	import { t, locale } from '$lib/translations';

	export let data;

	$: currentLang = $locale;

	$: filteredArticles = data?.articles
			? data.articles.filter(article => article.lang === currentLang && article).reverse().slice(0, 4)
			: [];
</script>

<section>
	<h2 class="title">
		{@html $t('home.join_us')}
	</h2>
	<div class="news-container">
		{#if filteredArticles && filteredArticles.length > 0}
			{#each filteredArticles as article}
				<Article data={article} />
			{/each}
		{/if}
	</div>
	<SocialLinks />
</section>

<style lang="scss">

	section {
		padding: 0 100px;
		overflow-x: hidden;
		margin-bottom: 80px;

		& > .title {
			font-size: 60px;
			line-height: 99%;
			text-transform: uppercase;
			color: white;
			font-weight: 900;
			font-style: italic;
			margin-bottom: 70px;
			text-align: center;

			& > .yellow {
				color: #fed500;
			}
		}
	}

	.news-container {
		display: flex;
		gap: 36px;
		overflow-x: auto;
		width: 1308px;
		padding: 10px 0 26px 0;

        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #fed500;
            border-radius: 5px;
        }

        &::-webkit-scrollbar-track {
            background-color: #161616;
            border-radius: 5px;
        }
	}

	@media screen and (max-width: 1400px) {
		.news-container {
			width: 973px;
		}
	}

	@media screen and (max-width: 1200px) {
		section {
			padding: 5px;
		}
	}

	@media screen and (max-width: 1100px) {
		.news-container {
			width: 637px;
		}
	}

	@media screen and (max-width: 1000px) {
		section {

			& > .title {
				font-size: 35pt;
			}
		}
	}

	@media screen and (max-width: 700px) {
		.news-container {
			width: 330px!important;
			//justify-content: center;
		}
	}

	@media screen and (max-width: 600px) {
		section {
			//margin-top: 20rem;

			& > .title {
				font-size: 30pt;
			}
		}
	}

	@media screen and (max-width: 500px) {
		section {

			& > .title {
				margin-bottom: 20px!important;
			}
		}
	}

	@media screen and (max-width: 380px) {
		section {
			margin-top: 13rem!important;

			& > .title {
				font-size: 25pt!important;
			}
		}
	}
</style>